export const VALIDATION_MOHF = 'VALIDATION_MOHF';
export const VALIDATION_ITSMY = 'VALIDATION_ITSMY';
export const VALIDATION_HEALTH_PARTNERS = 'VALIDATION_HEALTH_PARTNERS';
export const VALIDATION_FRANK = 'VALIDATION_FRANK';
export const VALIDATION_PHOENIX_PUBLIC = 'VALIDATION_PHOENIX_PUBLIC';
export const VALIDATION_HUNTER_PUBLIC = "VALIDATION_HUNTER_PUBLIC";

export const rebateScriptMedicareColorOptions = [
    ['Green', true],
    ['Other', false],
];

export function getRebateScriptConfig(AonConfig) {
    const { ENVIRONMENT_ID, ENVIRONMENT_ID_MOHF, ENVIRONMENT_ID_ITSMY } = AonConfig.deployment;
    let validationType = '';
    let rebateScript = '';
    const { rebate_script_template } = AonConfig.corporate;
    if (rebate_script_template === 'health_partners') {
        rebateScript = '/static/partials/rebate/script_health_partners.html'
        validationType = VALIDATION_HEALTH_PARTNERS;
    } else if (rebate_script_template === 'frank') {
        rebateScript = '/static/partials/rebate/script_frank.html'
        validationType = VALIDATION_MOHF;
    } else if (rebate_script_template === 'phoenix') {
        rebateScript = '/static/partials/rebate/script_phoenix_operator.html'
        validationType = VALIDATION_ITSMY;
    } else if (rebate_script_template === 'hunter') {
        rebateScript = '/static/partials/rebate/script_hunter_operator.html'
        validationType = VALIDATION_ITSMY;
    } else if (rebate_script_template === 'hunter_public') {
        rebateScript = '/static/partials/rebate/script_hunter_public.html'
        validationType = VALIDATION_HUNTER_PUBLIC;
    } else if (rebate_script_template === 'phoenix_public') {
        rebateScript = '/static/partials/rebate/script_phoenix_public.html'
        validationType = VALIDATION_PHOENIX_PUBLIC;
    } else if (ENVIRONMENT_ID === ENVIRONMENT_ID_ITSMY) {
        rebateScript = '/static/partials/rebate/script_itsmy.html'
        validationType = VALIDATION_ITSMY;
    } else if (ENVIRONMENT_ID === ENVIRONMENT_ID_MOHF) {
        rebateScript = '/static/partials/rebate/script_mohf.html'
        validationType = VALIDATION_MOHF;
    }

    return {
        rebateScript,
        validationType,
    };
}

export function formatDate(date) {
    return [
        date.getDate(),
        date.getMonth() + 1,
        date.getFullYear(),
    ].join('/');
}

export function formatJoinDate(application) {
    const date = _.get(application, 'payment.join_date');
    if (!date) {
        return 'N/A';
    }
    return formatDate(date);
}

export function getRebateTierIncome(application, AonApplicationService) {
    const choices = AonApplicationService.getRebateTierChoices(application);
    return choices[_.get(application, 'policy.rebate_tier')][1];
}

function validateMohf(application) {
    const covered = _.get(application, 'rebate_script.applicant_covered_by_policy', null);
    const child_only = _.get(application, 'rebate_script.child_only_policy', null);
    if (covered === false && child_only === false) {
        return false;
    }

    const declaration_correct = _.get(application, 'rebate_script.declare_correct', null);
    if (declaration_correct === false) {
        return false;
    }

    return true;
}

function validateItsmy(application) {
    const covered = _.get(application, 'rebate_script.applicant_covered_by_policy', null);
    if (covered === false) {
        return false;
    }

    const declaration_correct = _.get(application, 'rebate_script.declare_correct', null);
    if (declaration_correct === false) {
        return false;
    }

    return true;
}

function validateHealthPartners(application) {
    const others_on_policy = _.get(application, 'rebate_script.other_people_on_policy', null);
    if (others_on_policy === null) {
        return true;
    } else if (others_on_policy === true) {
        return false;
    }

    const agree_to_answer_questions = _.get(application, 'rebate_script.agree_to_answer_questions', null);
    if (agree_to_answer_questions === false) {
        return false;
    }

    const medicare_card_green = _.get(application, 'rebate_script.medicare_card_green', null);
    if (medicare_card_green === false) {
        return false;
    }

    const rebate_tier_correct = _.get(application, 'rebate_script.rebate_tier_correct', null);
    if (rebate_tier_correct === false) {
        return false;
    }

    const reduced_premium_on_start_date = _.get(application, 'rebate_script.reduced_premium_on_start_date', null);
    if (reduced_premium_on_start_date === false) {
        return false;
    }

    const declaration_correct = _.get(application, 'rebate_script.declare_correct', null);
    if (declaration_correct === false) {
        return false;
    }

    const played_recording = _.get(application, 'rebate_script.played_new_member_declaration_recording', null);
    if (played_recording !== true) {
        return false;
    }

    return true;
}

function validateFrank(application) {
    const covered = _.get(application, 'rebate_script.applicant_covered_by_policy', null);
    const child_only = _.get(application, 'rebate_script.child_only_policy', null);
    if (covered === false && child_only === false) {
        return false;
    }

    const others_on_policy = _.get(application, 'rebate_script.other_people_on_policy', null);
    if (others_on_policy === null) {
        return true;
    } else if (others_on_policy === true) {
        return false;
    }

    const declaration_correct = _.get(application, 'rebate_script.declare_correct', null);
    if (declaration_correct === false) {
        return false;
    }

    if (_.get(this, 'verbal_rebate.errors.rebate_tier')) {
        return false;
    }

    return true;
}

function validatePhoenixPublic(application) {
    // If they select no to either of these questions, the form is 'valid' in the sense that
    // we need to let them submit, but they will not actually have filled out the verbal rebate,
    // so the backend will not regard them as having completed the rebate script
    const collect = _.get(application, 'rebate_script.agree_to_information_collection', null);
    if (collect === null) {
        return true;
    } else if (collect === false) {
        return true;
    }

    const covered = _.get(application, 'rebate_script.applicant_covered_by_policy', null);
    if (covered === false) {
        return true;
    }

    const medicare = _.get(application, 'rebate_script.all_eligible_for_medicare', null);
    if (medicare === false) {
        return false;
    }

    return validateItsmy(application);
}

export function isRebateScriptValid(application, validationType) {
    if ([VALIDATION_MOHF, VALIDATION_ITSMY, VALIDATION_FRANK].includes(validationType)) {
        const collect = _.get(application, 'rebate_script.agree_to_information_collection', null);
        if (collect === null) {
            return true;
        } else if (collect === false) {
            return false;
        }

        const medicare = _.get(application, 'rebate_script.all_eligible_for_medicare', null);
        if (medicare === false) {
            return false;
        }
    }

    switch (validationType) {
        case VALIDATION_MOHF:
            return validateMohf(application);
        case VALIDATION_ITSMY:
            return validateItsmy(application);
        case VALIDATION_HEALTH_PARTNERS:
            return validateHealthPartners(application);
        case VALIDATION_FRANK:
            return validateFrank(application);
        case VALIDATION_PHOENIX_PUBLIC:
            return validatePhoenixPublic(application);
        case VALIDATION_HUNTER_PUBLIC:
            // Todo: We will need to change this to Hunter validation later
            return validatePhoenixPublic(application);
        default:
            return true;
    }
}


// WEBPACK FOOTER //
// ./src/utility/rebate-script.js